import { c as o, e as s, g as e, az as i, k as h } from "./define-element-XpjsV6s1.js";
const a = {
  key: 0,
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, f = {
  key: 1,
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, r = {
  key: 2,
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, v = {
  key: 3,
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, p = {
  key: 4,
  role: "presentation",
  focusable: "false",
  width: "8",
  height: "8",
  viewBox: "0 0 8 8"
}, d = {
  key: 5,
  role: "presentation",
  focusable: "false",
  width: "8",
  height: "2",
  viewBox: "0 0 8 2"
}, c = {
  key: 6,
  viewBox: "0 0 185.343 185.343",
  role: "presentation",
  focusable: "false"
}, w = {
  key: 7,
  viewBox: "0 0 24 24",
  role: "presentation",
  focusable: "false"
}, m = {
  key: 8,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640",
  role: "presentation",
  focusable: "false"
}, g = {
  key: 9,
  viewBox: "0 0 24 24",
  role: "presentation",
  focusable: "false"
}, u = {
  key: 10,
  viewBox: "0 0 38 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, x = {
  key: 11,
  viewBox: "0 0 38 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation",
  focusable: "false"
}, z = {
  __name: "Icon",
  props: {
    name: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    const t = n;
    return (L, l) => t.name === "visa" ? (o(), s("svg", a, l[0] || (l[0] = [
      e("g", null, [
        e("rect", {
          stroke: "#DDD",
          fill: "#FFF",
          x: ".25",
          y: ".25",
          width: "23.5",
          height: "15.5",
          rx: "2"
        }),
        e("path", {
          d: "M2.788 5.914A7.201 7.201 0 0 0 1 5.237l.028-.125h2.737c.371.013.672.125.77.519l.595 2.836.182.854 1.666-4.21h1.799l-2.674 6.167H4.304L2.788 5.914Zm7.312 5.37H8.399l1.064-6.172h1.7L10.1 11.284Zm6.167-6.021-.232 1.333-.153-.066a3.054 3.054 0 0 0-1.268-.236c-.671 0-.972.269-.98.531 0 .29.365.48.96.762.98.44 1.435.979 1.428 1.681-.014 1.28-1.176 2.108-2.96 2.108-.764-.007-1.5-.158-1.898-.328l.238-1.386.224.099c.553.23.917.328 1.596.328.49 0 1.015-.19 1.022-.604 0-.27-.224-.466-.882-.769-.644-.295-1.505-.788-1.491-1.674C11.878 5.84 13.06 5 14.74 5c.658 0 1.19.138 1.526.263Zm2.26 3.834h1.415c-.07-.308-.392-1.786-.392-1.786l-.12-.531c-.083.23-.23.604-.223.59l-.68 1.727Zm2.1-3.985L22 11.284h-1.575s-.154-.71-.203-.926h-2.184l-.357.926h-1.785l2.527-5.66c.175-.4.483-.512.889-.512h1.316Z",
          fill: "#1434CB"
        })
      ], -1)
    ]))) : t.name === "mastercard" ? (o(), s("svg", f, l[1] || (l[1] = [
      e("rect", {
        fill: "#252525",
        height: "16",
        rx: "2",
        width: "24"
      }, null, -1),
      e("circle", {
        cx: "9",
        cy: "8",
        fill: "#eb001b",
        r: "5"
      }, null, -1),
      e("circle", {
        cx: "15",
        cy: "8",
        fill: "#f79e1b",
        r: "5"
      }, null, -1),
      e("path", {
        d: "M12 4c1.214.912 2 2.364 2 4s-.786 3.088-2 4c-1.214-.912-2-2.364-2-4s.786-3.088 2-4z",
        fill: "#ff5f00"
      }, null, -1)
    ]))) : t.name === "amex" ? (o(), s("svg", r, l[2] || (l[2] = [
      i('<rect fill="#016fd0" height="16" rx="2" width="24"></rect><path d="M13.764 13.394V7.692l10.148.01v1.574l-1.173 1.254 1.173 1.265v1.608h-1.873l-.995-1.098-.988 1.102z" fill="#fffffe"></path><path d="M14.442 12.769v-4.45h3.772v1.026h-2.55v.695h2.49v1.008h-2.49v.684h2.55v1.037z" fill="#016fd0"></path><path d="m18.195 12.769 2.088-2.227-2.088-2.222h1.616l1.275 1.41 1.28-1.41h1.546v.035l-2.043 2.187 2.043 2.164v.063H22.35l-1.298-1.424-1.285 1.424z" fill="#016fd0"></path><path d="M14.237 2.632h2.446l.86 1.95v-1.95h3.02l.52 1.462.523-1.462h2.306v5.701H11.725z" fill="#fffffe"></path><g fill="#016fd0"><path d="m14.7 3.251-1.974 4.446h1.354l.373-.89h2.018l.372.89h1.387L16.265 3.25zm.17 2.558.592-1.415.592 1.415z"></path><path d="M18.212 7.696V3.25l1.903.006.98 2.733.985-2.74h1.832v4.446l-1.179.01V4.653L21.62 7.696h-1.075l-1.136-3.054v3.054z"></path></g>', 6)
    ]))) : t.name === "discover" ? (o(), s("svg", v, l[3] || (l[3] = [
      e("path", {
        d: "M21.997 15.75H22c.955.008 1.74-.773 1.751-1.746V2.006a1.789 1.789 0 0 0-.52-1.25A1.72 1.72 0 0 0 21.997.25H2.001A1.718 1.718 0 0 0 .77.757c-.33.33-.517.779-.521 1.247v11.99c.004.47.191.92.52 1.25.329.328.771.51 1.233.506h19.994Zm0 .5h-.002.002Z",
        stroke: "#ddd",
        fill: "#fff"
      }, null, -1),
      e("path", {
        d: "M12.612 16h9.385A1.986 1.986 0 0 0 24 14.03v-2.358A38.74 38.74 0 0 1 12.612 16Z",
        fill: "#F27712"
      }, null, -1),
      e("path", {
        d: "M23.172 9.296h-.852l-.96-1.266h-.091v1.266h-.695V6.152H21.6c.803 0 1.266.33 1.266.927 0 .488-.29.802-.81.902l1.116 1.315Zm-1.026-2.193c0-.306-.232-.463-.662-.463h-.215v.952h.199c.446 0 .678-.166.678-.489Zm-4.005-.951h1.97v.53h-1.275v.703h1.225v.538h-1.225v.852h1.274v.53h-1.97V6.152Zm-2.235 3.227L14.4 6.143h.761l.952 2.119.96-2.119h.745L16.295 9.38h-.389Zm-6.298-.008c-1.059 0-1.887-.72-1.887-1.655 0-.91.845-1.647 1.904-1.647.298 0 .546.058.852.19v.729a1.241 1.241 0 0 0-.869-.356c-.662 0-1.167.48-1.167 1.084 0 .637.497 1.092 1.2 1.092.315 0 .555-.1.836-.347v.728a2.13 2.13 0 0 1-.869.182ZM7.506 8.336c0 .613-.505 1.035-1.233 1.035-.53 0-.91-.182-1.233-.596l.455-.389c.157.282.422.422.753.422.315 0 .538-.19.538-.438 0-.141-.066-.249-.207-.331a2.88 2.88 0 0 0-.48-.183c-.653-.206-.877-.43-.877-.868 0-.514.48-.903 1.109-.903.397 0 .753.125 1.051.356l-.364.414a.761.761 0 0 0-.563-.248c-.298 0-.513.149-.513.347 0 .166.124.257.538.398.794.248 1.026.48 1.026.993v-.009ZM4.088 6.152h.695v3.153h-.695V6.152ZM1.854 9.305H.828V6.152h1.026c1.125 0 1.903.645 1.903 1.572 0 .472-.231.919-.637 1.217-.348.248-.737.364-1.274.364h.008Zm.81-2.367c-.23-.182-.496-.248-.95-.248h-.191v2.085h.19c.447 0 .728-.083.952-.248.24-.199.38-.497.38-.803 0-.306-.14-.596-.38-.786Z",
        fill: "#000"
      }, null, -1),
      e("path", {
        d: "M12.414 6.069c-.91 0-1.655.728-1.655 1.63 0 .96.711 1.68 1.655 1.68a1.64 1.64 0 0 0 1.655-1.655c0-.927-.72-1.655-1.655-1.655Z",
        fill: "#F27712"
      }, null, -1)
    ]))) : t.name === "plus" ? (o(), s("svg", p, l[4] || (l[4] = [
      e("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 5v3h2V5h3V3H5V0H3v3H0v2h3z",
        fill: "currentColor"
      }, null, -1)
    ]))) : t.name === "minus" ? (o(), s("svg", d, l[5] || (l[5] = [
      e("path", {
        fill: "currentColor",
        d: "M0 0h8v2H0z"
      }, null, -1)
    ]))) : t.name === "dots" ? (o(), s("svg", c, l[6] || (l[6] = [
      e("path", { d: `M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175
            l74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934
            c4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z` }, null, -1)
    ]))) : t.name === "bag" ? (o(), s("svg", w, l[7] || (l[7] = [
      e("path", { d: "M18 7h-3V6a3 3 0 0 0-6 0v1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm-7-1a1 1 0 0 1 2 0v1h-2V6zm6 13H7V9h2v1.5a1 1 0 0 0 2 0V9h2v1.5a1 1 0 0 0 2 0V9h2v10z" }, null, -1)
    ]))) : t.name === "shopping-cart" ? (o(), s("svg", m, l[8] || (l[8] = [
      e("path", { d: "M256 128L256 192L384 192L384 128C384 92.7 355.3 64 320 64C284.7 64 256 92.7 256 128zM224 224L128 224L128 512L512 512L512 224L416 224L416 320L384 320L384 224L256 224L256 320L224 320L224 224zM224 192L224 128C224 75 267 32 320 32C373 32 416 75 416 128L416 192L544 192L544 544L96 544L96 192L224 192z" }, null, -1)
    ]))) : t.name === "circle" ? (o(), s("svg", g, l[9] || (l[9] = [
      e("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "2"
      }, null, -1)
    ]))) : t.name === "apple_pay" ? (o(), s("svg", u, l[10] || (l[10] = [
      e("rect", {
        width: "38",
        height: "24",
        rx: "4",
        fill: "#000"
      }, null, -1),
      e("path", {
        d: "M12.7 8.3c.4-.5.7-1.2.6-1.9-.6 0-1.4.4-1.8.9-.4.5-.7 1.1-.6 1.8.7.1 1.4-.3 1.8-.8zm.6 1c-1-.1-1.9.6-2.4.6-.5 0-1.2-.5-2-.4-.9 0-1.9.5-2.4 1.3-1 1.8-.3 4.5.7 6 .5.7 1 1.5 1.8 1.5.8 0 1-.5 1.9-.5.9 0 1.1.5 1.9.5.8 0 1.3-.8 1.8-1.5.5-.8.7-1.6.7-1.7 0 0-1.5-.6-1.5-2.3 0-1.5 1.2-2.2 1.2-2.3-.6-1-1.7-1.1-1.7-1.1z",
        fill: "#FFF"
      }, null, -1),
      e("text", {
        x: "19.5",
        y: "16.5",
        "font-family": "-apple-system, 'Helvetica Neue', Helvetica, Arial, sans-serif",
        "font-size": "8.5",
        "font-weight": "600",
        fill: "#FFF"
      }, " Pay ", -1)
    ]))) : t.name === "google_pay" ? (o(), s("svg", x, l[11] || (l[11] = [
      e("rect", {
        width: "38",
        height: "24",
        rx: "4",
        fill: "#FFF",
        stroke: "#E8E8E8",
        "stroke-width": "0.5"
      }, null, -1),
      e("path", {
        d: "M11 12.8v1.3h3.2c-.1.8-.9 2.4-3.2 2.4-1.9 0-3.5-1.6-3.5-3.5S9.1 9.5 11 9.5c1.1 0 1.8.5 2.2.8l1-.9A5 5 0 0 0 11 8C8.2 8 6 10.2 6 13s2.2 5 5 5c2.9 0 4.8-2 4.8-4.9 0-.3 0-.6-.1-.9H11z",
        fill: "#4285F4"
      }, null, -1),
      e("text", {
        x: "19.5",
        y: "16.5",
        "font-family": "'Google Sans', Roboto, Arial, sans-serif",
        "font-size": "8.5",
        "font-weight": "500",
        fill: "#3C4043"
      }, " Pay ", -1)
    ]))) : h("", !0);
  }
};
export {
  z as _
};
